export const createJiraIssueUserPreferencesKey = `default-jira-project`;

export const createJiraTabFiltersUserPreferencesKey = 'jira-tab:filters';

export const createJiraTabCreateIssueUserPreferencesKey =
  'jira-tab:create-issue';
